import React from "react";
import { MessageType } from "../../constants";
import { formateDateTime } from '../../utils';
import FileIcon from "../../static/images/icon-file.svg";
import DownloadIcon from "../../static/images/icon-download.svg";
import Ticket from "./chatElements/ticket";
import { CustomCardSingle } from "./chatElements/CustomCard";


function JsonTemplate({ message, regenDoc }) {
    const content = JSON.parse((message.content))
    return (
        <>
            {content.type.toLowerCase() === MessageType.document ?
                <div className="grop_message">
                    <div onClick={() => regenDoc(content.document.docId)} className="download-policy-message message">
                        <div className="download-policy">
                            <img src={FileIcon} className="icon-file" alt="" /><p>Document</p><img src={DownloadIcon} className="icon-download" alt="" />
                        </div>

                    </div>
                </div>
                : null}
            {content.type && (content.type.toLowerCase() === "selection" || content.type === "freezeSelection" || content.type === "CallBackSelection") ?
                < div className="grop_message">
                    <div className="message" >{content.display_value} </div>
                </div>
                : null}
            {content.type && (content.type.toLowerCase() === "custrequestcallback") ?
                < div className="grop_message">
                    <div className="message" >{content.title} </div>
                </div>
                : null}

            {content.type && content.type === "BookingSelection" ?
                < div className="grop_message">
                    {content.display_value != "Other Bookings" ?
                        <div className="message withbooking" >
                            <div class="product-info">
                                <>

                                    <CustomCardSingle
                                        content={content}
                                        className='invert'
                                    />
                                    {/* <div class="card" >
                                        <img class="prd" src={content.display_logo} alt="logo" />
                                        <div class="prd-info">
                                            <span>{content.display_value}</span>
                                            <h4>{content.display_value}</h4>
                                            <span class="prd-detail">{content.display_discription}</span>
                                        </div>
                                    </div>
                                    <div class="policy-no">
                                        <span>Policy Number</span>
                                        <span>817522370993</span>
                                    </div> */}
                                </>
                            </div>
                        </div>
                        :
                        <div className="message"> Need help with another policy?</div>

                    }
                </div>

                : null}
            {content.type && content.type === "PolicyCopy" ?
                < div className="grop_message">
                    <div className="message" >{content.display_value} </div>
                </div>
                : null}
            {content.type && content.type === "TicketSelection" ?
                < div className="grop_message ">
                    {content.display_value != "Another Query" ?
                        <div className="message withbooking" >
                            <div class="product-info">
                                <>

                                    <Ticket
                                        ticketId={content.display_value}
                                        regarding={content.display_discription}
                                        ticketResolution={{
                                            text: content.ref_key,
                                            value: content.ref_value
                                        }}
                                    />
                                </>
                            </div>
                        </div>
                        :
                        <div class="message">
                            {content.display_discription}
                        </div>

                    }
                </div>
                : null}

        </>
    )
}


export default function MotorCustomerMessage({ messages, regenDoc, isHistoryMessgage }) {
    return (

        <li className="me">
             <div className={`grop_message msg-detials ${messages[messages.length - 1].readAt ? "read" : messages[messages.length - 1].deliveredAt ? "delivered" : messages[messages.length - 1].sentAt ? "received":null }`}>
                {formateDateTime(messages[messages.length - 1].sentAt)}
            </div>
            {messages.map((item) => (
                <>
                    {
                        item.type === 'json' ?
                            <JsonTemplate regenDoc={regenDoc} message={item} ></JsonTemplate>
                            :
                            <div className="grop_message">
                                <div className="message"> {item.content} </div>
                            </div>
                    }
                </>
            ))}
           {/* <div className={`grop_message msg-detials ${messages[messages.length - 1].readAt ? "read" : messages[messages.length - 1].deliveredAt ? "delivered" : messages[messages.length - 1].sentAt ? "received":null }`}>
                {formateDateTime(messages[messages.length - 1].sentAt)}
            </div> */}
            

        </li>

    );
}
